import {
  type BrowserInfo,
  BrowserInfoEnum,
} from "@b2bportal/payment-methods-api";

export const collectBrowserInfo = (): BrowserInfo => ({
  timeZoneOffset: new Date().getTimezoneOffset(),
  acceptHeader:
    "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8",
  userAgent: window.navigator.userAgent,
  language: window.navigator.language,
  origin: window.location.origin,
  javascriptEnabled: true,
  screenWidth: window.innerWidth,
  screenHeight: window.innerHeight,
  javaEnabled: false,
  colorDepth: window.screen.colorDepth,
  BrowserInfo: BrowserInfoEnum.WebBrowserInfo,
});
